import React, { PureComponent } from 'react';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here
import './style.scss';

class StatCard extends PureComponent {
    state = {};

    render() {
        const { data, literals, entity } = this.props;
        let fallos =
            data.fallo === 0 ? (
                <Literal
                    literal={
                        literals['label_no_failed_syncs_integration'] ||
                        'label_no_failed_syncs_integration'
                    }
                />
            ) : (
                <div>
                    <span>{data.fallo} </span>
                    <Literal
                        literal={
                            literals['label_total_failed_sync_integration'] ||
                            'label_total_failed_sync_integration'
                        }
                    />
                </div>
            );
        let tagStyle = data.fallo === 0 ? 'integration-stat-succeed' : 'integration-stat-failed';
        let tagLiteral =
            data.fallo === 0
                ? literals['label_stat_succeed_integration'] || 'label_stat_succeed_integration'
                : literals['label_stat_failed_integration'] || 'label_stat_failed_integration';
        return (
            <div className="integration-stats-card">
                <div className="entity">
                    <Literal
                        className="integration-entity-text"
                        literal={literals['integration_entity_text']}
                    />
                    <span className="integration-stat-total-value"> · {data.total} </span>
                    <Literal
                        className="integration-stat-total-value"
                        literal={
                            literals[`label_total_sync_${entity}_integration`] ||
                            `label_total_sync_${entity}_integration`
                        }
                    />
                </div>
                <div className="integration-stat-detail-values">
                    <div>
                        <span>{data.creadas} </span>
                        <Literal
                            literal={
                                literals[`label_total_creaciones_${entity}_integration`] ||
                                `label_total_creaciones_${entity}_integration`
                            }
                        />
                    </div>
                    <div>
                        <span>{data.modificadas} </span>
                        <Literal
                            literal={
                                literals[`label_total_actualizaciones_${entity}_integration`] ||
                                `label_total_actualizaciones_${entity}_integration`
                            }
                        />
                    </div>
                    <div>
                        <span>{data.borradas} </span>
                        <Literal
                            literal={
                                literals[`label_total_borrados_${entity}_integration`] ||
                                `label_total_borrados_${entity}_integration`
                            }
                        />
                    </div>
                    <div>{fallos}</div>
                </div>
                <div className="right">
                    <div className={tagStyle}>{<Literal literal={tagLiteral} />}</div>
                </div>
            </div>
        );
    }
}

export default StatCard;
